import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { AUTOMATION_QUERY_KEYS } from '../Automation/queryKeys';

interface MutationVariables {
	templateId: string;
	stepId: string;
	step: Api.IEmailAutomationStep;
	impersonationContext?: Api.IImpersonationContext;
}

export function useAutomationTemplateStepEmailUpdateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IEmailAutomationStep, variables: MutationVariables) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ templateId, stepId, step, impersonationContext }: MutationVariables) => {
			return userSession.webServiceHelper.callAsync<Api.IEmailAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/Email/${encodeURIComponent(stepId)}`,
					impersonationContext,
				}),
				'PUT',
				step
			);
		},
		onError,
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(variables.templateId) });
			onSuccess?.(data, variables);
		},
	});
}
